import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface LineChartProps {
  labels: string[];
  data: number[];
  title: string;
}

const LineChart: React.FC<LineChartProps> = ({ labels, data, title }) => {
  const [colors, setColors] = useState({
    textColor: '',
    gridColor: '',
  });

  const updateColors = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    setColors({
      textColor: rootStyles.getPropertyValue('--text-color').trim(),
      gridColor: rootStyles.getPropertyValue('--grid-color-chart').trim(),
    });
  };

  useEffect(() => {
    updateColors();

    const observer = new MutationObserver(() => {
      updateColors();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    return () => observer.disconnect();
  }, []);

  // Normalizar labels y registrar para depuración
  const processedLabels: string[] = Array.isArray(labels)
    ? labels
    : labels !== undefined && labels !== null
      ? [String(labels)]
      : [];

  const chartData = {
    labels: processedLabels,
    datasets: [
      {
        label: 'Datos de respuesta',
        data,
        fill: false,
        borderColor: '#27ae60',
        backgroundColor: '#27ae60',
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          color: colors.textColor,
        },
      },
      title: {
        display: true,
        text: title,
        color: colors.textColor,
      },
    },
    scales: {
      x: {
        ticks: {
          color: colors.textColor,
        },
        grid: {
          color: colors.gridColor,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: colors.textColor,
        },
        grid: {
          color: colors.gridColor,
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default LineChart;
